module.exports = __webpack_public_path__ + "img/31_4.bac6aba9.png";